<template>
  <div>
    <div>
      <div
        v-if="!hasFileAuto && hasFileCargo"
        class="mb-6"
      >
        <p class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
          We already have your Cargo Insurance policy on file. Please provide
          the name of your Insurance Agency for your Auto Insurance policy so we
          can go request your Certificate of Insurance (COI). We’ll request it
          immediately.
        </p>
        <p class="mb-4 border-b-2 border-light-gray text-left text-body-color">
          Insurance Agency (Required)
        </p>
        <insurance-form
          ref="insuranceForm"
          name="auto_liability_insurance"
          :data="data"
          :step-name="stepName"
          source-step-name="Insurance-1"
          :update-field="updateField"
        />
      </div>
      <div
        v-if="hasFileAuto && !hasFileCargo"
        class="mb-6"
      >
        <p class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
          We already have your Auto Insurance policy on file. Please provide the
          name of your Insurance Agency for your Cargo Insurance policy so we
          can go request your Certificate of Insurance (COI). We’ll request it
          immediately.
        </p>
        <p class="mb-4 border-b-2 border-light-gray text-left text-body-color">
          Insurance Agency (Required)
        </p>
        <insurance-form
          ref="insuranceFormHasFile"
          name="auto_liability_insurance"
          :data="data"
          :step-name="stepName"
          source-step-name="Insurance-1"
          :update-field="updateField"
        />
      </div>
      <div v-if="(!hasFileAuto && !hasFileCargo) || calculateFirstTime">
        <div class="mb-6">
          <p class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
            Please provide the name of your Insurance Agency so we can go
            request your Certificate of Insurance (COI). We’ll request it
            immediately.
          </p>
          <p
            class="mb-4 border-b-2 border-light-gray text-left text-body-color"
          >
            Insurance Agency (Required)
          </p>
          <insurance-form
            ref="insuranceForm"
            name="auto_liability_insurance"
            :data="data"
            :step-name="stepName"
            source-step-name="Insurance-1"
            :update-field="updateField"
          />
        </div>
        <p class="text-2xs italic text-body-color">
          By providing your insurance agency contact information, you are
          authorizing Highway to request your insurance policies, including all
          related documentation, from your agency and to be listed as
          Certificate Holder on your COI.
        </p>
      </div>

      <div v-if="hasFileAuto && hasFileCargo && !calculateFirstTime">
        <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
          Good news! We already have your Certificate of Insurance on file.
          Please confirm all your policies are present below.
        </h4>

        <div class="flex flex-col md:flex-row md:flex-wrap md:gap-3">
          <div
            v-for="policy in insurancePolicies"
            :key="policy.number"
            class="md:flex-2 max-width-container mb-8 flex flex-col items-start rounded-md border border-light-gray p-4 shadow-lg md:mb-0 md:w-1/2"
          >
            <div class="mb-2 flex w-full justify-between md:h-12">
              <div class="flex flex-col">
                <h4 class="text-left text-lg">
                  {{ insurance_types[policy.is_type] }}
                </h4>
                <p
                  class="mb-1 whitespace-nowrap text-xs font-normal uppercase text-steel-800"
                >
                  {{ subheading(policy) }}
                </p>
              </div>
              <div
                class="flex h-6 items-center justify-center gap-1 rounded-full bg-forest-500 px-2 py-0.5 text-white"
              >
                <p>Active</p>
              </div>
            </div>
            <div class="break-words">
              <p class="text-xs font-medium text-steel-800">Insurer Name</p>
              <p class="text-neutral-1100 text-xs font-medium">
                {{ formatTitleCase(policy.insurance_insurer.name) }}
              </p>
            </div>
            <span class="my-2 w-full border-b border-steel-200"></span>

            <div class="w-full overflow-hidden break-words">
              <p class="text-xs font-medium text-steel-800">Policy #</p>
              <p class="text-neutral-1100 text-xs font-medium">
                {{ policy.number || '' }}
              </p>
            </div>
            <span class="my-2 w-full border-b border-steel-200"></span>

            <div class="flex w-full">
              <div class="w-[100px]">
                <p class="text-xs font-medium text-steel-800">Limit</p>
                <p
                  v-if="!isWorkerCompensation(policy.is_type)"
                  class="text-neutral-1100 text-xs font-medium"
                >
                  {{
                    calculateLimit(policy?.insurance_limits[0]?.value || null)
                  }}
                  {{
                    calculateCurrency(policy?.insurance_certificate?.currency)
                  }}
                </p>
                <p
                  v-else
                  class="text-neutral-1100 text-xs font-medium"
                >
                  {{ hasStatutoryLimit(policy) ? 'Statutory' : 'Other' }}
                </p>
              </div>
              <span class="mx-4 my-1 border-l border-steel-200"></span>

              <div class="ml-5 w-1/2">
                <p class="text-xs font-medium text-steel-800">
                  Expiration Date
                </p>
                <p class="text-neutral-1100 text-xs font-medium">
                  {{ calculateExpirationDate(policy?.expiration_date || null) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="calculateFirstTime">
        <div class="mb-6">
          <p class="text-dark-gray text-left mb-8 mt-4 sm:mt-2">
            Please provide the name of your Insurance Agency so we can go request
            your Certificate of Insurance (COI). We’ll request it immediately.
          </p>
          <p class="text-body-color text-left border-b-2 border-light-gray mb-4">
            Insurance Agency (Required)
          </p>
          <insurance-form 
            ref="insuranceForm"
            name="auto_liability_insurance"
            :data="data"
            :stepName="stepName"
            sourceStepName="Insurance-1"
            :updateField="updateField"
          />
        </div>
      </div> -->
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      @next="handleNext"
      @back="handleBack"
      @edit="handleEdit"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { computed, watch } from 'vue';
import stepInformation from '@/common/stepInformation';
import { capitalize } from '@/common/validators';
import moment from 'moment';
import _ from 'lodash';
import InsuranceForm from '@/components/InsuranceForm.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'InsuranceStepOne',
  components: {
    FormNavigationButtons,
    InsuranceForm,
  },
  props: {
    data: Object,
    updateField: Function,
    formPosition: Number,
    title: String,
    stepName: String,
    nextStep: Function,
    skipStep: Function,
    screenSize: String,
  },
  setup(_, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Insurance-1';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const hasFileCargoVal = computed(() => {
      const cargo = store.state.insurance.insurancePolicies?.find(
        (insurance) =>
          insurance?.is_type === 'motor_truck_cargo' &&
          insurance?.status === 'active'
      );
      return !!cargo;
    });
    const hasFileAutoVal = computed(() => {
      const auto = store.state.insurance.insurancePolicies?.find(
        (insurance) =>
          insurance?.is_type === 'automobile_liability' &&
          insurance?.status === 'active'
      );
      return !!auto;
    });
    const buttonsToDisplay = computed(() => {
      if (firstTime.value) return 'continue-save';
      // Check for auto and cargo policies, if not both, return 'continue-save'
      if (!(hasFileAutoVal.value && hasFileCargoVal.value))
        return 'continue-save';
      return 'continue-edit';
    });
    const isButtonDisabled = false;

    // nextChecks: Checks to be reviewed when the user clicks the Continue button (but before any store.state.formRoutes.activeStep changes)
    const nextCheck1 = computed(
      () => !hasFileAutoVal.value && hasFileCargoVal.value
    );
    const nextCheck2 = computed(() => !firstTime.value);

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );

      if (nextCheck1.value) {
        store.commit(
          'addFormDebugMessage',
          componentIdentifier +
            ': nextCheck1 is TRUE (No auto but does have cargo), moving ahead 3 steps to Insurance-4'
        );
        return formRouter.moveToStepByIdentifier('Insurance-4');
      } else {
        store.commit(
          'addFormDebugMessage',
          componentIdentifier +
            ": nextCheck1 is FALSE ('No auto but does have cargo' is not true)"
        );
      }

      if (nextCheck2.value) {
        store.commit(
          'addFormDebugMessage',
          componentIdentifier +
            ': nextCheck2 is TRUE (firstTime.Insurance is false), moving ahead 2 steps to Insurance-3'
        );
        return formRouter.moveToStepByIdentifier('Insurance-3');
      } else {
        store.commit(
          'addFormDebugMessage',
          componentIdentifier +
            ': nextCheck2 is FALSE (firstTime.Insurance is true)'
        );
      }

      formRouter.moveToNextStep();
    };

    // backChecks: Checks to be reviewed when the user clicks the Back button (but before any store.state.formRoutes.activeStep changes)
    const backCheck1 = computed(() => !store.state.firstTime['Certifications']);

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );

      if (backCheck1.value) {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck1 is TRUE (firstTime.Certifications is false), moving to Certifications-1'
        );
        store.commit('toggleDisabledButton', {
          bool: false,
          source: 'InsuranceStepOne #10',
        });
        return formRouter.moveToStepByIdentifier('Certifications-1');
      } else {
        store.commit(
          'addFormDebugMessage',
          'BACK CHECK | ' +
            componentIdentifier +
            ': backCheck1 is FALSE (firstTime.Certifications is true)'
        );
      }
      store.commit('toggleDisabledButton', {
        bool: false,
        source: 'InsuranceStepOne #11',
      });
      formRouter.moveToPreviousStep();
    };

    const handleEdit = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleEdit' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.editActiveStep();
    };

    watch(
      [hasFileAutoVal, hasFileCargoVal, isNavigationDisabled],
      ([val1, val2, val3]) => {
        // console.log('hasFileAuto, hasFileCargo', val1, val2, firstTime.value, 'InsuranceStepOne #1')
        if (val1 && val2 && val3 && firstTime.value) {
          store.commit('firstTime/updateStepFirstTime', {
            step: 'Insurance',
            value: false,
          });
          store.commit('toggleDisabledButton', {
            bool: false,
            source: 'InsuranceStepOne #9',
          });
        } else {
          // store.commit("toggleDisabledButton", { bool: true, source: 'InsuranceStepOne #2' });
        }
      }
    );

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleEdit,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      hasFileAutoVal,
      hasFileCargoVal,
      emitExitModal,
    };
  },
  data() {
    return {
      items: [],
      coiOnRecord: false,
      insurance_types: {
        commercial_general_liability: 'General Liability',
        automobile_liability: 'Auto',
        motor_truck_cargo: 'Cargo',
        workers_compensation: "Workers' Compensation",
        trailer_interchange: 'Trailer Interchange',
        // refrigeration_breakdown: "Reefer Breakdown", // TODO: We are ignoring refrigeration_breakdown for now. We are currently only showing the types for Auto and Cargo.
      },
    };
  },
  computed: {
    ...mapGetters('insurance', ['getHasFileCargo', 'getHasFileAuto']),
    hasFileCargo() {
      return this.getHasFileCargo;
    },
    hasFileAuto() {
      return this.getHasFileAuto;
    },

    calculateFirstTime() {
      if (this.$store.state.firstTime?.['Insurance']) {
        return true;
      } else if (this.coiOnRecord) {
        return false;
      } else if (!this.data.auto_liability_insurance?.id) {
        return true;
      } else {
        return false;
      }
    },

    carrierId() {
      return (
        this.$store.state.users.currentUser?.company?.carrier_id ||
        this.$store.state.users.currentUser?.requested_carrier_id ||
        this.$store.state.carriers?.carrierData?.identity.id
      );
    },
    insurancePolicies() {
      let filteredInsurance = this.data.insurance_policies.filter((el) => {
        return (
          [
            'commercial_general_liability',
            'automobile_liability',
            'motor_truck_cargo',
            'workers_compensation',
            'trailer_interchange',
            // "refrigeration_breakdown", // TODO: We are ignoring refrigeration_breakdown for now. We are currently only showing the types for Auto and Cargo.
          ].includes(el.is_type) && el.status === 'active'
        );
      });

      // Sort the array list
      return _.sortBy(filteredInsurance, function (element) {
        var rank = {
          commercial_general_liability: 1,
          automobile_liability: 2,
          motor_truck_cargo: 3,
          workers_compensation: 4,
          trailer_interchange: 5,
        };

        return rank[element.is_type];
      });
    },
  },

  watch: {
    stepName: function (val) {
      if (val === 'Insurance-1') {
        this.continueButtonValidation();
        this.refetchUser();
        // this.updateFirstTime(this.calculateFirstTime);
        // !this.insurancePolicies.length
        //   ? this.updateFirstTime(true)
        //   : this.updateFirstTime(false);
        if (this.data.insurance_policies?.length > 0) {
          this.updateField(
            'auto_liability_insurance',
            this.data.insurance_policies[0]
          );

          if (
            this.stepName === 'Insurance-1' &&
            ((this.hasFileAuto && !this.hasFileCargo) ||
              (!this.hasFileAuto && this.hasFileCargo))
          ) {
            this.$store.commit('toggleDisabledButton', {
              bool: true,
              source: 'InsuranceStepOne #7',
            });
            return;
          } else {
            this.$store.commit('toggleDisabledButton', {
              bool: false,
              source: 'InsuranceStepOne #8',
            });
          }

          if (this.data.insurance_policies[1]) {
            this.updateField(
              'cargo_insurance',
              this.data.insurance_policies[1]
            );
          } else {
            this.updateField(
              'cargo_insurance',
              this.data.insurance_policies[0]
            );
          }
        }
      }
    },
  },
  async beforeMount() {
    this.items = stepInformation.insurance.auto_liability;
    await this.findPolicy();
  },
  async mounted() {
    this.items = stepInformation.insurance.auto_liability;
    await this.findPolicy();
  },
  methods: {
    formatTitleCase(string) {
      const normalizedString = this.nullTextify(string);
      if (normalizedString === 'N/A') return 'N/A';

      return normalizedString
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    nullTextify: function (value, nullVal = 'N/A') {
      if (value == null) {
        return nullVal;
      } else {
        return value;
      }
    },
    calculateCurrency(currency) {
      if (currency !== 'usd') {
        return currency.toUpperCase();
      } else {
        return '';
      }
    },
    subheading(policy) {
      if (!policy?.is_type) return '';

      if (policy?.scheduled_autos) {
        return 'scheduled autos';
      }
      if (policy?.is_refrigeration_breakdown_included) {
        return 'includes reefer breakdown';
      }

      return '';
    },
    isWorkerCompensation(policyType) {
      return policyType === 'workers_compensation';
    },
    hasStatutoryLimit({ statutory_limits }) {
      return !!statutory_limits;
    },
    async refetchUser() {
      // await this.$store.dispatch("users/identifyUser");
      await this.$store.dispatch('users/serverRefreshCurrentUser');
    },
    capitalizeEachWord(string) {
      return string && capitalize(string);
    },
    async updateFirstTime(firstTime) {
      await this.$store.commit('firstTime/updateStepFirstTime', {
        step: 'Insurance',
        value: firstTime,
      });
    },
    async findPolicy() {
      const searchPolicies = await this.$store.dispatch(
        'insurance/getPolicy',
        this.carrierId
      );
      if (
        [200, 201].includes(searchPolicies.status) &&
        searchPolicies.data?.length > 0
      ) {
        this.coiOnRecord = true;

        const findAuto = searchPolicies.data.find(
          (item) => item.is_type === 'automobile_liability'
        );
        const findCargo = searchPolicies.data.find(
          (item) => item.is_type === 'motor_truck_cargo'
        );

        this.updateField('auto_liability_insurance', findAuto);
        this.updateField('cargo_insurance', findCargo);

        if (this.stepName === 'Insurance-1') {
          if (
            (this.hasFileAuto && !this.hasFileCargo) ||
            (!this.hasFileAuto && this.hasFileCargo)
          ) {
            this.$store.commit('toggleDisabledButton', {
              bool: true,
              source: 'InsuranceStepOne #1',
            });
          } else {
            this.$store.commit('toggleDisabledButton', {
              bool: false,
              source: 'InsuranceStepOne #2',
            });
          }
        }
      }
    },
    calculateLimit(limit) {
      if (limit) {
        return '$' + Math.round(limit).toLocaleString();
      } else {
        return '-';
      }
    },
    calculateExpirationDate(expiration) {
      if (expiration) {
        return moment(expiration).format('M/D/YY');
      } else {
        return '';
      }
    },

    continueButtonValidation() {
      if (
        this.$refs?.insuranceForm?.agency !== null &&
        this.$refs?.insuranceForm?.agency !== undefined
      ) {
        const { name, phone_number, email } =
          this.$refs?.insuranceForm?.agency || {};
        if (!name || !phone_number || !email) {
          this.$store.commit('toggleDisabledButton', {
            bool: true,
            source: 'InsuranceStepOne #3',
          });
        } else {
          this.$store.commit('toggleDisabledButton', {
            bool: false,
            source: 'InsuranceStepOne #4',
          });
        }
      } else {
        if (this.stepName == 'Insurance-1') {
          this.$store.commit('toggleDisabledButton', {
            bool: true,
            source: 'InsuranceStepOne #5',
          });
        } else {
          this.$store.commit('toggleDisabledButton', {
            bool: false,
            source: 'InsuranceStepOne #6',
          });
        }
      }
    },
  },
};
</script>
<style scoped>
p {
  text-align: left;
}

@media (min-width: 768px) {
  .max-width-container {
    max-width: calc(50% - 10px);
  }
}
</style>
